const MS_PER_MINUTE = 60000;

/** ISO string dalam waktu lokal */
export function localISO(d: Date = new Date()): string {
  const shifted = new Date(d.getTime() - d.getTimezoneOffset() * MS_PER_MINUTE);
  return shifted.toISOString();
}

/** Tanggal lokal "YYYY-MM-DD". */
export function localISODate(d: Date = new Date()): string {
  return localISO(d).slice(0, 10);
}

/** Normalisasi nilai ISO datetime dari API menjadi "YYYY-MM-DD" lokal, untuk <input type="date">. */
export function toDateInput(v: unknown): unknown {
  return typeof v === "string" && v.includes("T")
    ? localISODate(new Date(v))
    : v;
}

/** Salinan objek dengan key tanggal dinormalisasi untuk <input type="date">. */
export function toDateInputs<T extends Record<string, any>>(
  obj: T,
  keys: string[] = [
    "tanggal_audit",
    "periode_audit_dari",
    "periode_audit_sd",
    "pmik_str_exp",
    "pmik_sik_exp",
  ]
): T {
  const out: any = { ...obj };
  for (const k of keys) out[k] = toDateInput(out[k]);
  return out;
}

export function parseLocalDate(v: unknown): Date | null {
  if (typeof v !== "string" || v.length < 10) return null;

  const [y, m, d] = v
    .slice(0, 10)
    .split("-")
    .map(Number);

  return y && m && d ? new Date(y, m - 1, d) : null;
}
